export default function useFeatureFlagsEnv() {
  const { featureFlags, tracker } = useRuntimeConfig().public;

  function isFeatureEnabled(key: keyof typeof featureFlags): boolean {
    if (!key || !featureFlags[key]) {
      return false;
    }

    // @ts-ignore
    return !!featureFlags[key]?.isEnabled;
  }

  function isUserAllowed(usersListFromEnv: string = ''): boolean {
    if (!usersListFromEnv) {
      return true;
    }

    const { userId } = useUserData();

    const usersList = usersListFromEnv.split(',');

    return usersList.includes(String(userId.value));
  }

  function hasUserPermissionToTest(key: keyof typeof featureFlags): boolean {
    return isFeatureEnabled(key) && isUserAllowed(featureFlags[key].testUsers);
  }

  const isBetByTestModeEnabled = ref<boolean>(featureFlags.betByTestMode);

  const isBetByEnabled = ref<boolean>(
    !isBetByTestModeEnabled.value && featureFlags.betByActive,
  );

  const isBetByWidgetEnabled = ref<boolean>(featureFlags.betByWidgetEnabled);

  const isAltenarTestModeEnabled = ref<boolean>(featureFlags.altenarTestMode);

  const isAltenarEnabled = ref<boolean>(
    !isAltenarTestModeEnabled.value && featureFlags.altenarActive,
  );

  const isTaboolaEnabled = ref<boolean>(!!tracker.taboolaId);

  const isKwaiPixelEnabled = ref<boolean>(!!tracker.kwaiPixel);

  const isCactusSportsbookTestModeEnabled = ref<boolean>(
    featureFlags.cactusSportsbook.testPage,
  );

  const isCactusSportsbookEnabled = computed<boolean>(() => {
    if (isBetByEnabled.value) {
      return false;
    }

    return hasUserPermissionToTest('cactusSportsbook');
  });

  const isDisableBrandGtm = ref<boolean>(featureFlags.disableBrandGtm);

  const isPokerEnabled = computed(() => {
    return hasUserPermissionToTest('pokerSection');
  });

  const isIrpfEnabled = computed(() => {
    return hasUserPermissionToTest('irpf');
  });

  const isWithdrawalReceiptEnabled = computed(() => {
    return hasUserPermissionToTest('withdrawalReceipt');
  });

  return {
    isBetByEnabled,
    isBetByTestModeEnabled,
    isBetByWidgetEnabled,
    isAltenarEnabled,
    isAltenarTestModeEnabled,
    isCactusSportsbookEnabled,
    isCactusSportsbookTestModeEnabled,
    isDisableBrandGtm,
    isTaboolaEnabled,
    isKwaiPixelEnabled,
    isPokerEnabled,
    isIrpfEnabled,
    isWithdrawalReceiptEnabled,
  };
}
